module.exports = __webpack_public_path__ + "static/media/pagoQr.f08f115c.svg";